import React from 'react';
// components
import Form from '../../../components/Form/Form';
import { Link } from 'react-router-dom';
import FieldError from '../../../components/Form/FieldError';
import FormErrors from '../../../components/Form/FormErrors';
import PasswordInput from '../../../components/PasswordInput/PasswordInput';
import Button from '../../../components/Button/Button';
// utils
import { toast } from 'react-toastify';
import { withFormik } from 'formik';
import * as yup from 'yup';
import validations from '../../../utils/validations';
import { responseErrors } from '../../../utils/response';
// styles
import styles from '../PasswordReset.mod.css';

export const PasswordResetForm = ({
  values,
  touched,
  errors = {},
  dirty,
  isSubmitting,
  handleChange,
  handleBlur,
  handleSubmit,
}) => (
  <Form className={styles.formWrapper} onSubmit={handleSubmit}>
    <h2 className={styles.title}>Reset password</h2>
    <FormErrors errors={errors.full_messages} />

    <div className="form-control">
      <div className="field-wrapper">
        <PasswordInput
          name="password"
          placeholder="New Password"
          value={values.password}
          onChange={handleChange}
          onBlur={handleBlur}
          invalid={errors.password && touched.password}
        />
        <FieldError error={errors.password} touched={touched.password} />
      </div>
    </div>
    <div className="form-control">
      <div className="field-wrapper">
        <PasswordInput
          name="password_confirmation"
          placeholder="Repeat Password"
          value={values.password_confirmation}
          onChange={handleChange}
          onBlur={handleBlur}
          invalid={
            errors.password_confirmation && touched.password_confirmation
          }
        />
        <FieldError
          error={errors.password_confirmation}
          touched={touched.password_confirmation}
        />
      </div>
    </div>
    <div className={styles.buttons}>
      <Button
        type="submit"
        primary
        isLoading={isSubmitting}
        disabled={isSubmitting}
      >
        Submit
      </Button>
      <Link className={styles.link} to="/login">
        Back to Log in
      </Link>
    </div>
  </Form>
);

export default withFormik({
  mapPropsToValues: () => ({ password: '', password_confirmation: '' }),
  validationSchema: yup.object().shape({
    password: validations.password,
    password_confirmation: yup
      .string()
      .oneOf([yup.ref('password'), null], "Passwords don't match")
      .required('Password confirm is required!'),
  }),
  handleSubmit: (
    values,
    { setSubmitting, setErrors, props: { onSubmit, history } }
  ) => {
    onSubmit(values)
      .then(() => {
        setSubmitting(false);
        toast.info('Your password successfully changed.');
        history.push('/profile');
      })
      .catch(response => {
        setErrors(responseErrors(response));
        setSubmitting(false);
      });
  },
  displayName: 'PasswordResetForm',
})(PasswordResetForm);



// WEBPACK FOOTER //
// ./src/containers/PasswordReset/components/PasswordResetForm.jsx